import React, { Component } from 'react';
import { withRouter } from 'react-router'
import Constants from './Constants.js';
import $ from 'jquery';

class TeacherActivity extends Component {

  constructor(props) {
    super(props);
    this.state = {
      users: []
    };
  }	
  componentWillMount() {
  	const self = this;

		$.ajax({
      type: 'GET',
      url: `${Constants.API_HOST}metrics/teacher_activity/`,
      contentType: 'application/json',
      dataType: "json",
      xhrFields: { withCredentials:true },
      success: function success(data) {
      	self.setState({
      		'users': data
      	})

      },
      error: function error(data) {

      }
    });

  }	

  render() {
    return (
      <div>
      	<h1>TeacherActivity</h1>


				<table className="table">
					<thead>
						<tr>
							<th>
								Email
							</th>
							<th>
								Unique Days
							</th>
							<th>
								Which Days
							</th>
						</tr>
					</thead>
          <tbody>
          {
            this.state.users.map(function(user) {
              return (
                <tr key={user.email}>
                  <td>
                    {user.first_name}
                  </td>
                  <td>
                    {user.last_name}
                  </td>
                  <td>
                    {user.email}
                  </td>
                  <td>
                    {user.unique_days}
                  </td> 
                  <td>
                  	{user.days}
                  </td>
                </tr>
              )
            })
          }
          </tbody>

				</table>  

      </div>
    );
  }
}

export default withRouter(TeacherActivity);


// WEBPACK FOOTER //
// ./src/components/TeacherActivity.js